export default [
  {
    id: 1,
    title: "Orange",
    image: "🍊",
    price: 1099,
    category: 1,
    sale: false,
  },
  {
    id: 2,
    title: "Kokosnuss",
    image: "🥥",
    price: 1499,
    category: 3,
    sale: false,
  },
  {
    id: 3,
    title: "Aubergine",
    image: "🍆",
    price: 999,
    category: 2,
    sale: false,
  },
  {
    id: 4,
    title: "Tomate",
    image: "🍅",
    price: 510,
    category: 2,
    sale: true,
  },
  {
    id: 5,
    title: "Birne",
    image: "🍐",
    price: 3999,
    category: 1,
    sale: false,
  },
  {
    id: 6,
    title: "Erdnuss",
    image: "🥜",
    price: 3999,
    category: 3,
    sale: false,
  },
  {
    id: 7,
    title: "Kirsche",
    image: "🍒",
    price: 299,
    category: 1,
    sale: true,
  },
  {
    id: 8,
    title: "Kartoffel",
    image: "🥔",
    price: 599,
    category: 2,
    sale: false,
  },
];

export const categories = [
  { categoryId: 1, name: "Obst" },
  { categoryId: 2, name: "Gemüse" },
  { categoryId: 3, name: "Nüsse" },
];
